import {
  CurrencyBoostType,
  CurrencyCoinPack,
  CurrencyDiamondPack,
  GetAppBoostsSalesQuery,
} from '../../../../../__gqltypes__';

type BoostSaleConfig = GetAppBoostsSalesQuery['app']['boostsSales'][number];
type VanitySaleConfig = { id: string; amount: number; offerPercentage: number };

export type TargetedProduct = {
  id: string;
  amount?: number;
  saleConfigs: (CurrencyDiamondPack | CurrencyCoinPack | BoostSaleConfig | VanitySaleConfig)[];
  boostType?: CurrencyBoostType;
};
export type AppSalesConfig = {
  saleConfigs: (CurrencyDiamondPack | CurrencyCoinPack | BoostSaleConfig | VanitySaleConfig)[];
  targetedProducts: TargetedProduct[];
};

export enum SaleType {
  DIAMOND = 'DIAMOND',
  COIN = 'COIN',
  BOOST = 'BOOST',
  FRAME = 'FRAME',
  VINYL = 'VINYL',
  STICKER = 'STICKER',
}
